import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { getDashboardDetails } from '../../api/dashboard/dashboard-details';
import { DashboardHeader, OpenEnquiry, Project } from '../../components/dashboard';
import styles from '../../components/dashboard/data-container.module.scss';
import { Page } from '../../components/page';
const Dashboard = (props) => {
  const { title } = props;
  const { dashBoardData } = useLoaderData({})
  return (
    <Page className='dashboard' title={title} backLink={false}>
      <DashboardHeader values={dashBoardData.data} />
      <div className={styles.dashboardBody}>
        <div style={{ width: '100%' }}>
          <OpenEnquiry enquiries={dashBoardData.data.quotation_list} />
          <br />
          <Project items={dashBoardData.data.item_list}/>
        </div>
     
      </div>
    </Page>
  )
}

Dashboard.propTypes = {
  ...Page.propTypes

}

Dashboard.Loader = async () => {
 
    const dashBoardData = await getDashboardDetails()
    if (!dashBoardData) {
      throw new Error('Invalid Data')
    }

    return { dashBoardData }
 
}

export default Dashboard
